import { useQuery } from "@tanstack/react-query"
import { useEffect, useRef } from "react"
import { createDepositedBalanceQueryOptions } from "../../queries/balanceQueries"
import type { IntentsUserId } from "../../types/intentsUserId"
import { WNEAR_ASSET_ID, getLstAssetId } from "./config"

export interface NearStakingBalances {
  availableNear: bigint
  stakedLst: bigint
}

export function useNearStakingBalances(
  userId: IntentsUserId | null
): NearStakingBalances {
  const lstAssetId = getLstAssetId()
  const tokenIds = lstAssetId ? [WNEAR_ASSET_ID, lstAssetId] : [WNEAR_ASSET_ID]
  const balanceKey = `${userId ?? ""}:${lstAssetId ?? ""}`

  const { data } = useQuery(
    createDepositedBalanceQueryOptions({ userId, tokenIds })
  )
  const previousDataRef = useRef<{
    key: string
    data: NonNullable<typeof data>
  } | null>(null)
  const balances =
    data ??
    (previousDataRef.current?.key === balanceKey
      ? previousDataRef.current.data
      : undefined)

  useEffect(() => {
    if (data == null) return
    previousDataRef.current = { key: balanceKey, data }
  }, [balanceKey, data])

  return {
    availableNear: balances?.[WNEAR_ASSET_ID] ?? 0n,
    stakedLst: lstAssetId ? (balances?.[lstAssetId] ?? 0n) : 0n,
  }
}
